import { detailsKeyFor } from '../../utils/details_utils';

// Explicit whitelists: only the fields the details components consume reach the store,
// all camelCase. New API fields must be added here or they never reach components.
const normalizeTee = (tee) => {
  if (!tee) return tee;
  return {
    holeLabels: tee.hole_labels,
    holeData: tee.hole_data,
    par: tee.par,
    parSumFront: tee.par_sum_front,
    parSumBack: tee.par_sum_back,
    yardage: tee.yardage,
    yardageSumFront: tee.yardage_sum_front,
    yardageSumBack: tee.yardage_sum_back,
    courseName: tee.course_name,
  };
};

const normalizeNet = (net) => ({
  disposition: net.disposition,
  newStrokesByHole: net.new_strokes_by_hole,
  strokesByHole: net.strokes_by_hole,
  xesByHole: net.xes_by_hole,
  pointsByHole: net.points_by_hole,
  strikethroughsByHole: net.strikethroughs_by_hole,
  strokeSumFront: net.stroke_sum_front,
  strokeSumBack: net.stroke_sum_back,
  strokeSum: net.stroke_sum,
  tee: net.tee ? normalizeTee(net.tee) : net.tee,
});

const normalizeRound = (round) => ({
  id: round.id,
  name: round.name,
});

const normalizeMemberCard = (card) => ({
  memberIdStr: card.member_id_str,
  memberCardIdStr: card.member_card_id_str,
});

const normalizeAggregate = (agg) => ({
  idStr: agg.id_str,
  roundId: agg.round_id,
  startHole: agg.start_hole,
  memberIdsStr: agg.member_ids_str,
  // The DQ/WD/... reason, shown as the info circle in the scorecard's Tot
  // cell (legacy _sum.html.haml parity); per aggregate, so a multi-round
  // card shows the cause of the round being viewed.
  dispositionCause: agg.disposition_cause ?? '',
  memberCards: agg.member_cards?.map(normalizeMemberCard) ?? [],
  rounds: agg.rounds?.map(normalizeRound),
  childAggregates: agg.child_aggregates?.map(normalizeAggregate) ?? [],
  nets: agg.nets?.map(normalizeNet) ?? [],
});

// The aggregates_details endpoint answers with a bare array (rabl collection,
// no object root), in no guaranteed order.
const aggregatesArray = (data) => (Array.isArray(data) ? data : Object.values(data ?? {}));

// A single scorecard fetch: the one aggregate that was asked for.
export const normalizeDetails = (data) => {
  const aggregate = aggregatesArray(data)[0];
  return aggregate ? normalizeAggregate(aggregate) : '';
};

// A background refresh of several open scorecards, keyed the way the details
// slice is - by the players' member ids, never by the (unstable) aggregate id.
export const normalizeDetailsBatch = (data) =>
  aggregatesArray(data).reduce((acc, aggData) => {
    acc[detailsKeyFor(aggData.member_ids_str)] = normalizeAggregate(aggData);
    return acc;
  }, {});
